import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useRef,
} from "react";
import { Button, Col, Row, Spinner, Table, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable"; 
import moment from "moment";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import Confirm from "../Confirm";
// import TaskEdit from "./TaskEdit";
// import TaskView from "./TaskView";
// import Permissionhelper from "../common/Permissionhelper";
import * as constants from "../../constants/CONSTANT";
import trasportApi from "../../api/trasportApi";
import { formatDate } from "../../utils/helper";
import "./PurchaseOrder.css"

const RelatedListPurchaseOrder = ({ parent, refreshTaskList,table }) => {
  const [modalShow, setModalShow] = React.useState(false);
  const [task, setTask] = React.useState("");
  const [modalShowTask, setModalShowTask] = React.useState(false);
  const [modalShowTaskView, setModalShowTaskView] = React.useState(false);
  const [isFollowUp, setModalShowFollowUp] = React.useState(false);


  // Create table headers consisting of 4 columns.

  const [body, setBody] = useState([]);
//   useEffect(() => {
//     console.log(parent);
//     taskList();

//     if(table === 'Lead'){
//       setModalShowFollowUp(true);
//     }
//   }, []);

  // useEffect(() => {
  //   taskList();
  // }, [refreshTaskList]);

  useEffect(() => {
    taskList();
  }, []);

  const taskList = () => {
    console.log("parent?.id  ListViweRElated",parent?.id);
    async function init() {
      let PurchaseItem = await trasportApi.fetchPurchaseLineItemsByParentId(parent?.id);
      console.log('PurchaseItem',PurchaseItem);

      //console.log(tasks);
      if (PurchaseItem && PurchaseItem?.length > 0) {
        setBody(PurchaseItem);
      } else {
        setBody([]);
      }
    }
    init();
  };
  const handleDelete = (row) => {
    setModalShow(true);
    setTask(row);
  };

  const labels = {
    beforeSelect: " ",
  };

  // const deleteTask = async () => {
  //   ////console.log('task.id',task.id)
  //   const result = await trasportApi.deleteTaskById(task.id);
  //   ////console.log('result',result)
  //   if (result.success) {
  //     setTask("");
  //     setModalShow(false);
  //     taskList();
  //   }
  // };

  const submitTasks = () => {
    setModalShowTask(false);
    taskList();
  };

  const editTask = (row) => {
    setModalShowTask(true);
    setTask(row);
  };

  const viewTask = (row) => {
    setModalShowTaskView(true);
    setTask(row);
  };

  const Taskheader = [
    {
      title: "Title",
      prop: "title",
      cell: (row) => (
        <Link onClick={() => viewTask({ row })} state={parent}>
          {row.title}
        </Link>
      ),
    },
    { title: "Type", prop: "type" },
    { title: "Assigned", prop: "owner_name" },

    { title: "Status", prop: "status" },
    { title: "Priority", prop: "priority" },

    {
      title: "Target Date",
      prop: "targetdate",
      cell: (row) => formatDate(row.targetdate),
    },
    {
      title: "Created Date",
      prop: "createddate",
      cell: (row) => formatDate(row.createddate),
    },
    {
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <>
          <Button className="btn-sm mx-2" onClick={() => editTask({ row })}>
            <i className="fa-regular fa-pen-to-square"></i>
          </Button>
          {/* {Permissionhelper.checkPermission(constants.SUPER_ADMIN) && ( */}
            <Button
              className="btn-sm mx-2"
              variant="danger"
              onClick={() => handleDelete(row)}
            >
              <i className="fa-regular fa-trash-can"></i>
            </Button>
          {/* )} */}
        </>
      ),
    },
  ];

  const purchaseLineItemsHeader = [
    {
      title: 'S.No',
      prop: 'sr_no',
    },
    {
      title: 'Category',
      prop: 'category_name',
    
    },
    {
      title: 'Product',
      prop: 'product_name',
    
    },
    {
      'title': 'Packing Size', 'prop': 'packing_size', 
    },
    {
      'title': 'Quantity', 'prop': 'product_qty',
    },
    // {
    //   title: 'Rate Per',
    //   prop: 'rate_per',
      
    // },

    // {
    //       'title': 'SGST', 'prop': 'sgst', 
    //     },
    //     {
    //       'title': 'IGST', 'prop': 'igst', 
    //     },
    //     {
    //       'title': 'CGST', 'prop': 'cgst', 
    //     },
        {
          'title': 'Supplier Price', 'prop': 'supplier_price', 
        },
    // {
    //   'title': 'GST Amount', 'prop': 'gst_amt', 
    // },
    
       {
          title: 'Total Price',
          prop: 'id',
          cell: (row) => (
            <Form.Group style={{width : '100px'}}>
              <Form.Control
                disabled
                value={(Number(row?.product_qty) || 0) * (Number(row.supplier_price) || 0)}
              />
            </Form.Group>
          )
        },
    // {
    //   title: 'Total Price',
    //   prop: 'id',
      
    // },
    // {
    //   title: 'Comparing Price',
    //   prop: 'id',
     
    // }
  ];

//   const FollowUpheader = [
//     {
//       title: "FollowUp Title",
//       prop: "title",
//       cell: (row) => (
//         <Link onClick={() => viewTask({ row })} state={parent}>
//           {row.title}
//         </Link>
//       ),
//     },
//     { title: "Type", prop: "type" },
//     { title: "Assigned", prop: "owner_name" },

//     { title: "Status", prop: "status" },
//     { title: "Priority", prop: "priority" },

//     {
//       title: "Target Date",
//       prop: "targetdate",
//       cell: (row) => moment(row.targetdate).format("DD-MM-YYYY"),
//     },
//     {
//       title: "Created Date",
//       prop: "createddate",
//       cell: (row) => moment(row.createddate).format("DD-MM-YYYY"),
//     },
//     {
//       title: "Actions",
//       prop: "id",
//       cell: (row) => (
//         <>
//           <Button className="btn-sm mx-2" onClick={() => editTask({ row })}>
//             <i className="fa-regular fa-pen-to-square"></i>
//           </Button>
//           {Permissionhelper.checkPermission(constants.SUPER_ADMIN) && (
//             <Button
//               className="btn-sm mx-2"
//               variant="danger"
//               onClick={() => handleDelete(row)}
//             >
//               <i className="fa-regular fa-trash-can"></i>
//             </Button>
//           )}
//         </>
//       ),
//     },
//   ];

  const headers = purchaseLineItemsHeader
//   isFollowUp ? FollowUpheader :Taskheader

  return (
    <>
      {/* {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deleteTask={deleteTask}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="task"
        />
      )} */}
      {/* {modalShowTask && (
        <TaskEdit
          show={modalShowTask}
          onHide={() => setModalShowTask(false)}
          parentid={parent.id}
          task={task}
          table={table}
          submitTasks={submitTasks}
        />
      )} */}

      {/* {modalShowTaskView && (
        <TaskView
          show={modalShowTaskView}
          onHide={() => setModalShowTaskView(false)}
          parentid={parent.id}
          task={task}
          table={table}
          submitTasks={submitTasks}
        />
      )} */}

      {body ? (
        <DatatableWrapper
          body={body}
          headers={headers}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 5,
            },
          }}
        >
          <Row className="mb-4">
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            ></Col>
          </Row>
          <Table striped className="related-list-table shadow rounded sm " responsive={true}>
            <TableHeader />
            {
              (body && Array.isArray(body)) ?
                <TableBody />
                :
                <tbody className="">
                  <tr>
                    <td colSpan={100} align="center">
                      <div>
                        <Spinner />
                      </div>
                    </td>
                  </tr>
                </tbody>
            }
          </Table>
          <Pagination classes={{ buttonGroup: "", button: "bg-custom border-white" }} /> 
          {/*  //Added by shivani */}
        </DatatableWrapper>
      ) : (
        ""
      )}
    </>
  );
};

export default RelatedListPurchaseOrder;
